document.addEventListener('DOMContentLoaded', function() {

  var progressBar = document.getElementById('scroll-progress');
  if (progressBar) {
    window.addEventListener('scroll', function() {
      var scrollTop = window.pageYOffset;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight > 0) progressBar.style.width = (scrollTop / docHeight * 100) + '%';
    }, { passive: true });
  }

  var announceClose = document.getElementById('announce-close');
  var announceBar = document.getElementById('announce-bar');
  if (announceClose && announceBar) {
    announceClose.addEventListener('click', function() {
      announceBar.classList.add('dismissed');
    });
  }

  var nav = document.querySelector('.nav');
  if (nav) {
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 60) nav.classList.add('scrolled');
      else nav.classList.remove('scrolled');
    }, { passive: true });
  }

  var stickyBar = document.getElementById('sticky-buy-bar');
  var orderSection = document.getElementById('order');
  if (stickyBar && orderSection) {
    var stickyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('visible');
        } else {
          var rect = orderSection.getBoundingClientRect();
          if (rect.bottom < 0) stickyBar.classList.add('visible');
          else stickyBar.classList.remove('visible');
        }
      });
    }, { threshold: 0 });
    stickyObserver.observe(orderSection);
  }

  document.querySelectorAll('.faq-q').forEach(function(q) {
    q.addEventListener('click', function() {
      var item = q.parentElement;
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function(i) {
        i.classList.remove('open');
        var btn = i.querySelector('.faq-q');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('open');
        q.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.querySelectorAll('.hp-variant-card input[type="radio"]').forEach(function(radio) {
    radio.addEventListener('change', function() {
      document.querySelectorAll('.hp-variant-card').forEach(function(c) { c.classList.remove('active'); });
      radio.closest('.hp-variant-card').classList.add('active');
    });
  });

  function scrollToSection(id) {
    var target = document.getElementById(id);
    if (!target) return;
    var announce = document.getElementById('announce-bar');
    var navH = nav ? nav.offsetHeight : 0;
    var announceH = announce && !announce.classList.contains('dismissed') ? announce.offsetHeight : 0;
    var offset = navH + announceH + 20;
    var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: y, behavior: 'smooth' });
    var navLinks = document.getElementById('nav-links');
    if (navLinks && navLinks.classList.contains('mobile-open')) navLinks.classList.remove('mobile-open');
  }

  if (window.location.hash) {
    var hashId = window.location.hash.replace('#', '');
    if (hashId && document.getElementById(hashId)) {
      setTimeout(function() { scrollToSection(hashId); }, 100);
    }
  }

  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var href = a.getAttribute('href');
      if (href === '#') return;
      var id = href.replace('#', '');
      var target = document.getElementById(id);
      if (target) {
        e.preventDefault();
        history.replaceState(null, null, href);
        scrollToSection(id);
      }
    });
  });

  var openBtn = document.getElementById('mobile-open') || document.querySelector('.mobile-menu');
  var closeBtn = document.getElementById('mobile-close');
  var navLinks = document.getElementById('nav-links') || document.querySelector('.nav-links');
  if (openBtn && navLinks) {
    openBtn.addEventListener('click', function() { navLinks.classList.add('mobile-open'); });
  }
  if (closeBtn && navLinks) {
    closeBtn.addEventListener('click', function() { navLinks.classList.remove('mobile-open'); });
  }

  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vis');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    document.querySelectorAll('.reveal').forEach(function(el) { revealObserver.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el) { el.classList.add('vis'); });
  }

  var chatTrigger = document.getElementById('chat-widget-trigger');
  var chatPanel = document.getElementById('chat-widget-panel');
  var chatClose = document.getElementById('chat-widget-close');
  if (chatTrigger && chatPanel) {
    chatTrigger.addEventListener('click', function() {
      var open = chatPanel.getAttribute('aria-hidden') !== 'false';
      chatPanel.setAttribute('aria-hidden', open ? 'false' : 'true');
      chatTrigger.setAttribute('aria-expanded', open);
    });
  }
  if (chatClose && chatPanel && chatTrigger) {
    chatClose.addEventListener('click', function() {
      chatPanel.setAttribute('aria-hidden', 'true');
      chatTrigger.setAttribute('aria-expanded', 'false');
    });
  }

  var chatForm = document.getElementById('chat-widget-form');
  var chatFormWrap = document.getElementById('chat-widget-form-wrap');
  var chatSuccess = document.getElementById('chat-widget-success');
  var chatMessageEl = document.getElementById('chat-widget-message-el');
  if (chatForm && chatFormWrap && chatSuccess) {
    chatForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = chatForm.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      if (chatMessageEl) { chatMessageEl.textContent = ''; chatMessageEl.classList.remove('error', 'success'); }
      var formData = new FormData(chatForm);
      fetch('/contact#contact_form', { method: 'POST', body: formData })
        .then(function(res) {
          if (res.ok || res.redirected) {
            chatFormWrap.hidden = true;
            chatSuccess.hidden = false;
            chatForm.reset();
          } else {
            if (chatMessageEl) { chatMessageEl.textContent = 'Something went wrong. Please try again.'; chatMessageEl.classList.add('error'); }
            if (btn) btn.disabled = false;
          }
        })
        .catch(function() {
          if (chatMessageEl) { chatMessageEl.textContent = 'Something went wrong. Please try again.'; chatMessageEl.classList.add('error'); }
          if (btn) btn.disabled = false;
        });
    });
  }

});
